import React from "react";
import OverlapSection from "../section/OverlapSection";
import imageSrc from "../../assets/images/rescue_image.png";

const Rescue = () => {
  return (
    <div className="toLeft">
      <OverlapSection
        layoutClass="toLeft"
        imageUrl={imageSrc}
        mainTitle="SAVE LIFE JUST BY A POST"
        backText={
          "Be the hero of someone's life. \n Let us come together to make the change - to be the change. \n Let's post the rescue and be voice for the voiceless."
        }
        // buttonLink="/book"
      />
    </div>
  );
};

export default Rescue;
